import { DiContainer } from '@/modules/di/di-container';
import { notification, Modal } from 'antd';
import { BusinessOffersService } from '../services/business-offers.service';
import { fetchTradeOffersFx } from '../store/business-offers.store';
import { ILocalSortState } from '../store/offer-page.store';

const businessOffersService = DiContainer.get(BusinessOffersService);

const deleteTraderOffer = async (
  idx: number,
  successFoo?: () => Promise<void | unknown>,
) => {
  try {
    await businessOffersService.deleteBusinessOffer(idx);
    successFoo && (await successFoo());
    return notification.success({ message: 'Сделка успешно удалена' });
  } catch (err) {
    return notification.error({
      message: 'При удалении сделки возникла ошибка. Попробуйте, пожалуйста, позже',
    });
  }
};

export const deleteOffer = async (
  id: number,
  successFoo?: () => Promise<void | unknown>,
) => {
  Modal.confirm({
    title: 'Подтвердите действие',
    content: 'Вы уверены что хотите удалить данную сделку?',
    okText: 'да',
    cancelText: 'нет',
    onOk: async () => await deleteTraderOffer(id, successFoo),
  });
};

export const deleteSelectedOffers = async (
  sortState: ILocalSortState,
  selectedOffers: number[],
  setSelectedOffers: (val: number[]) => void,
) => {
  try {
    const res = {
      action: sortState.action.filter((item) => item.active).map((item) => item.value),
      agriculture: sortState.cultures
        .filter((item) => item.active)
        .map((item) => item.value),
      active: sortState.active.filter((item) => item.active).map((item) => item.value),
      sorting_direction: sortState.order,
      sorting_param: sortState.options.find((item) => item.active)?.val,
    };
    if (!selectedOffers || selectedOffers.length === 0) return;
    await businessOffersService.batchDeleteBusinessOffer(selectedOffers);
    await fetchTradeOffersFx(res);
    setSelectedOffers([]);
    notification.success({ message: 'Выбранные сделки успешно удалены' });
  } catch (err) {
    notification.warning({
      message:
        'При групповом удалении сделок произошла ошибка. Попробуйте, пожалуйста позже',
    });
  }
};
